import { FieldFormats } from './field-formats';
import { fieldTypes } from './field-types.js';
import { getSolrType } from './get-solr-type.js';
import { initializeFieldCategoryMapping } from './initialize-field-category-mapping.js';
import { canConvertFieldTypeWithoutDataLoss, ConversionCompatibility } from './can-convert-field-type-without-data-loss';
export const Utility = {
    FieldFormats,
    getSolrType,
    initializeFieldCategoryMapping,
    fieldTypes,
    canConvertFieldTypeWithoutDataLoss,
    ConversionCompatibility,
};
